import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  countLabel: {
    fontWeight: theme.typography.fontWeightBold,
    marginRight: theme.spacing(0.5)
  },
  alert: {
    marginBottom: theme.spacing(2)
  }
}));
